import Defaults from "./Defaults";

class NetworkWatcher {
  constructor() {
    this.onlineCallback = null;
    this.offlineCallback = null;
    this.isOnline = navigator.onLine;
    this.pingInterval = null;
    this.checkingConnectivity = false;
  }

  async checkConnectivity() {
    if (this.checkingConnectivity) return;
    this.checkingConnectivity = true;

    try {
      // Try to fetch a small resource to confirm actual connectivity
      const response = await fetch(Defaults.api + "/global/fetch", {
        method: 'GET',
        cache: 'no-cache',
        mode: 'no-cors'
      });

      // console.log(response.status)

      const isCurrentlyOnline = response.status === 0 || (response.status >= 200 && response.status < 300);

      if (isCurrentlyOnline !== this.isOnline) {
        this.isOnline = isCurrentlyOnline;
        if (isCurrentlyOnline && this.onlineCallback) {
          this.onlineCallback();
        } else if (!isCurrentlyOnline && this.offlineCallback) {
          this.offlineCallback();
        }
      }
    } catch (error) {
      // If fetch fails, we're offline
      if (this.isOnline) {
        this.isOnline = false;
        if (this.offlineCallback) {
          this.offlineCallback();
        }
      }
    } finally {
      this.checkingConnectivity = false;
    }
  }

  watch(onlineCallback, offlineCallback) {
    // Store callbacks
    this.onlineCallback = onlineCallback;
    this.offlineCallback = offlineCallback;

    // Initial check
    this.checkConnectivity();

    // Setup event listeners
    window.addEventListener('online', () => this.checkConnectivity());
    window.addEventListener('offline', () => this.checkConnectivity());

    // Setup periodic checking
    this.pingInterval = setInterval(() => this.checkConnectivity(), 30000);

    // Return cleanup function
    return () => {
      window.removeEventListener('online', () => this.checkConnectivity());
      window.removeEventListener('offline', () => this.checkConnectivity());
      if (this.pingInterval) {
        clearInterval(this.pingInterval);
        this.pingInterval = null;
      }
    };
  }
}

export default new NetworkWatcher();
